<template>
  <a-tabs v-model:activeKey="mode"
          class="tabs">
    <a-tab-pane key="code"
                :tab="$t('LoginPage.SimpleSignin.mobileSignin')">
      <a-form ref="newUserForm"
              class="form"
              :model="newUserState"
              name="basic"
              :wrapper-col="{ span: 24 }"
              autocomplete="off"
              layout="vertical"
              @finish="onNewUserFinish"
              @finish-failed="onNewUserFinishFailed">
        <a-form-item name="mobile"
                     :rules="[{ required: true, validator: validateMobile }]">
          <a-input v-model:value="newUserState.mobile"
                   :placeholder="$t('LoginPage.SimpleSignin.enterMobile')"
                   style="width: 100%"
                   autocomplete="off"
                   size="large">
            <template #prefix>
              <mobile-outlined />
            </template>
          </a-input>
        </a-form-item>
        <!-- <a-row :gutter="10">
          <a-col :span="16">
            <a-form-item name="vcode"
                         :rules="[{ required: true, validator: validateVCode }]">
              <a-input v-model:value="newUserState.vcode"
                       size="large"
                       autocomplete="off"
                       placeholder="请输入右侧验证码">
                <template #prefix>
                  <barcode-outlined />
                </template>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8"
                 class="vcode">
            <img :src='newUserState.vcodeGraph'
                 :alt="$t('LoginPage.ResetPassword.clickToRefresh')"
                 @click='refreshVCodeGraph' />
          </a-col>
        </a-row> -->
        <a-row :gutter="10"
               class="combo">
          <a-col :span="16">
            <a-form-item name="captcha"
                         :rules="[{ required: true, message: $t('LoginPage.SimpleSignin.enterCaptcha') }]">
              <a-input v-model:value="newUserState.captcha"
                       autocomplete="off"
                       :placeholder="$t('LoginPage.SimpleSignin.enterCaptcha')"
                       size="large">
                <template #prefix>
                  <code-outlined />
                </template>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8"
                 class="captcha">
            <count-down-button html-type="submit"
                               :text="$t('LoginPage.SimpleSignin.getCaptcha')"
                               :counting-text-post="$t('LoginPage.SimpleSignin.retryAfter')"
                               :disabled="!newUserState.isMobileValid"
                               size="large"
                               @click="getCaptcha"></count-down-button>
          </a-col>
        </a-row>
        <a-row>
          <a-button type="primary"
                    html-type="submit"
                    size="large"
                    style="width: 100%">{{ $t('LoginPage.SimpleSignin.signinOrSignUpButton') }}</a-button>
        </a-row>
      </a-form>
    </a-tab-pane>
    <a-tab-pane key="password"
                :tab="$t('LoginPage.SimpleSignin.accountSignin')"
                force-render>
      <a-form class="form"
              :model="passwordState"
              name="basic"
              :wrapper-col="{ span: 24 }"
              autocomplete="off"
              layout="vertical"
              @finish="onFinish"
              @finish-failed="onFinishFailed">
        <a-form-item name="user"
                     :rules="[{ required: true, message: $t('LoginPage.SimpleSignin.enterUsernameOrMobile') }]">
          <a-input v-model:value="passwordState.user"
                   :placeholder="$t('LoginPage.SimpleSignin.usernameOrMobile')"
                   style="width: 100%"
                   autocomplete="off"
                   size="large">
            <template #prefix>
              <user-outlined />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item name="password"
                     :rules="[{ required: true, message: $t('LoginPage.SimpleSignin.enterPassword') }]">
          <a-input-password v-model:value="passwordState.password"
                            :placeholder="$t('LoginPage.SimpleSignin.password')"
                            autocomplete="off"
                            size="large">
            <template #prefix>
              <lock-outlined />
            </template>
          </a-input-password>
        </a-form-item>
        <a-form-item>
          <a-col :span="24"
                 class="footer">
            <a href="#"
               style="float: right"
               @click.prevent.stop="toResetPassword">{{ $t('LoginPage.SimpleSignin.forgotPassword') }}</a>
          </a-col>
        </a-form-item>
        <a-row>
          <a-button type="primary"
                    html-type="submit"
                    size="large"
                    style="width: 100%">{{ $t('LoginPage.SimpleSignin.signinButton') }}</a-button>
        </a-row>
      </a-form>
    </a-tab-pane>
  </a-tabs>
  <a-row v-if="oauth2Components.length > 0 && props?.options?.otherLogin"
         class="oauth2">
    <span>{{ $t('LoginPage.SimpleSignin.otherSigninMethods') }}</span>
    <template v-for="item in oauth2Components"
              :key="item">
      <component :is="item"
                 class="item" />
    </template>
  </a-row>
</template>

<script setup lang="ts">
import { CORE_AXIOS, Http } from "@/core"
import { CountDownButton } from "@iota-cn/ui-components"
import { Validator } from "@iota-cn/util-validation"
import { message } from "ant-design-vue"
import type { Rule } from "ant-design-vue/lib/form"
import { container } from "tsyringe"
import { reactive, ref } from "vue"
import type { Router } from "vue-router"
import { CORE_ROUTER } from "../../../../core"
import { useLoginStore } from "../DefaultLoginPagePlugin"
import { RESETPASSWORD_PATH } from "../constants"
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const axios = container.resolve<Http>(CORE_AXIOS)

const mode = ref("code")

const emit = defineEmits(["success"])

const userStore = useLoginStore()

const passwordState = reactive({
  user: "",
  password: ""
})

const props = defineProps<{
  options: {
    otherLogin: boolean
    newWindowToResetPassword?: boolean
  }
}>()

const oauth2Components = userStore.$state.oauth2Components || []

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onFinish = async (values: any) => {
  values.username = values.user
  values.mobile = values.user
  const res = await userStore.signinOnly("/v1/api/signin", values)
  if (res) {
    emit("success", 200)
  }
}

const onFinishFailed = (errorInfo: string) => {
  console.log("Failed:", errorInfo)
}

const router = container.resolve<Router>(CORE_ROUTER)

const toResetPassword = () => {
  if (props.options.newWindowToResetPassword) {
    const href = router.resolve({ path: RESETPASSWORD_PATH })
    window.open(href.href, "_blank")
  } else {
    router.push({ path: RESETPASSWORD_PATH })
  }
}

const newUserState = reactive({
  mobile: "",
  captcha: "",
  isMobileValid: false,
  isNew: false,
  vcodeGraph: "",
  vcode: "",
  isVCodeValid: false
})

const getCaptcha = async () => {
  const mobile = newUserState.mobile
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  axios.post(userStore.$state.api?.fetchSmsValidationCode || "/v1/api/validations/smses", { mobile }).then((res: any) => {
    if (res.status === 403) {
      message.error(t('LoginPage.SimpleSignin.captchaRequestFrequent'))
    }
  })
}

const newUserForm = ref()
const onNewUserFinish = async () => {
  if (newUserState.isNew) {
    const newUser = {
      mobile: newUserState.mobile,
      username: newUserState.mobile,
      password: newUserState.mobile,
      captcha: newUserState.captcha
    }
    axios
      .post("/v1/api/signup", newUser)
      .then(async () => {
        const res = await userStore.signinOnly("/v1/api/signin", {
          mobile: newUserState.mobile,
          username: newUserState.mobile,
          password: newUserState.mobile
        })
        if (res) {
          emit("success", 200)
        }
      })
      .catch(() => {
        message.error(t('LoginPage.SignUpPage.signUpFailure'))
      })
  } else {
    const res = await userStore.signinOnly(userStore.$state.api?.signinByCode || "/v1/api/signin_by_code", {
      mobile: newUserState.mobile,
      captcha: newUserState.captcha
    })
    if (res) {
      emit("success", 200)
    }
  }
}

const onNewUserFinishFailed = () => { }

const refreshVCodeGraph = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  axios.get(`/v1/api/validations/codes?graph=${Math.random()}`).then((res: any) => {
    newUserState.vcodeGraph = res
  })
}

refreshVCodeGraph()

// const validateVCode = async (_rule: Rule, value: string) => {
//   if (value === undefined || value.length < 6) {
//     newUserState.isVCodeValid = false;
//     return Promise.reject(new Error("请输入正确的验证码"));
//   }

//   return axios
//     .get(`/v1/api/validations/codes/validate?vcode=${value}`)
//     .then(() => {
//       newUserState.isVCodeValid = true;
//       return Promise.resolve();
//     })
//     .catch(() => {
//       newUserState.isVCodeValid = false;
//       return Promise.reject(new Error("请输入正确的验证码"));
//     });
// };

const validateMobile = async (_rule: Rule, value: string) => {
  if (Validator.isPhone(value)) {
    newUserState.isMobileValid = true
    return axios
      .get(`/v1/api/validations/mobiles/validate?mobile=${value}`)
      .then(() => {
        newUserState.isNew = true
        return Promise.resolve()
      })
      .catch(() => {
        newUserState.isNew = false
        return Promise.resolve()
      })
  } else {
    newUserState.isMobileValid = false
    return Promise.reject(new Error(t('LoginPage.SimpleSignin.enterValidMobile')))
  }
}
</script>


<style scoped lang="less">
.tabs {
  width: 100%;

  // :deep(.ant-tabs-tab) {
  //   width: 96px;
  //   line-height: 40px;
  //   font-size: 16px;
  //   color: #002fa7;
  //   text-align: center;
  //   // border-bottom: 2px #002FA7 solid;
  //   margin: 0;
  //   display: block;

  //   margin-top: 24px;
  //   margin-bottom: 24px;
  // }

  // :deep(.ant-tabs-ink-bar) {
  //   bottom: 22px;
  // }


  .form {

    .combo {
      position: relative;
    }

    .captcha,
    .vcode {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 24px;

      img {
        height: 40px;
        cursor: pointer;
        width: 100%;
      }

      button {
        width: 100%;
        border: none;
      }
    }
  }
}

.oauth2 {
  margin-top: 20px;
  display: flex;
  justify-content: start;
  align-items: center;

  .item {
    font-size: 24px;
    margin: 0 20px 0 20px;
  }
}
</style>
